export default "__VITE_ASSET__HMAjXTgJ__"